import React from 'react';
import {Color} from '../../models/product';
import ProductColorCheckbox from './ProductColorCheckbox';

type ProductColorChooserProps = {
  colors: Color[];
  selectedColorIds: string[];
  setSelectedColors: (colors: string[]) => void;
  maxSelectedColors: number;
};

const ProductColorChooser: React.FC<ProductColorChooserProps> = (
  props: ProductColorChooserProps
) => {
  const {colors, selectedColorIds, setSelectedColors, maxSelectedColors} =
    props;

  return (
    <div className="productColorChooser">
      {colors.map(c => (
        <ProductColorCheckbox
          rgb={c.rgbs[0]}
          trimRgb={c.trim_rgb}
          colorName={c.name}
          key={c.id}
          selected={selectedColorIds.includes(String(c.id))}
          toggleSelected={() => {
            if (selectedColorIds.includes(String(c.id))) {
              setSelectedColors(
                selectedColorIds.filter(id => id !== String(c.id))
              );
            } else if (selectedColorIds.length < maxSelectedColors) {
              setSelectedColors(selectedColorIds.concat(String(c.id)));
            }
          }}
        />
      ))}
    </div>
  );
};

export default ProductColorChooser;
